import dayjs from 'dayjs';

// DataStore serializes each model's syncExpression predicate and stores it with the model's
// sync metadata. If the serialized predicate differs from the previous session's (even by a
// millisecond in an embedded date), DataStore discards the delta-sync checkpoint and performs
// a FULL base sync of that model. Computing predicate dates with a raw `dayjs()` therefore
// forced a 3-4 minute full sync on every page refresh/app open (Sentry:
// datastore-full-sync-detected, causes startup-after-page-refresh / startup-initial-sync).
//
// Anchoring all dynamic predicate dates to the start of the current local day keeps the
// serialized predicate byte-identical across restarts within a day, so DataStore can run its
// fast delta sync instead. The sync window start drifts by at most one day, which is
// irrelevant for the 60-day / 6-month windows we use.

export function daysAgoAtStartOfDay(days: number): string {
  return dayjs().startOf('day').subtract(days, 'day').toISOString();
}

export function monthsAgoAtStartOfDay(months: number): string {
  return dayjs().startOf('day').subtract(months, 'month').toISOString();
}

// Stable far-future date for models whose sync is intentionally disabled (the predicate can
// never match). Must be a constant for the same reason as above: a computed `now + 5 years`
// changed every session and forced full re-syncs.
export const NEVER_SYNC_FUTURE_DATE = '2099-01-01T00:00:00.000Z';
